const toggleFaq = (element) => {
    const answer = element.nextElementSibling;
    const parent = element.parentElement;
    parent.classList.toggle('reading');

    // Get computed styles
    const style = window.getComputedStyle(element);
    const paddingTop = parseFloat(style.paddingTop) + 10; // Add 10px to account for answer padding
    
    const parentStyle = window.getComputedStyle(parent);
    const borderColor = parentStyle.borderColor;

    // scrollHeight already includes content + paddingTop + paddingBottom
    // But we want to make sure collapsed state is 0
    const answerHeight = answer.scrollHeight;

    if (answer.style.maxHeight) {
        answer.style.maxHeight = null; // collapse
        // parent.style.removeProperty('--il-item-bg-color');
    } else {
        // parent.style.setProperty('--il-item-bg-color', borderColor);
        answer.style.maxHeight = paddingTop + answerHeight + "px"; // expand
    }

    element.classList.toggle('active');
}

const initFaq = () => {
    const faqs = document.querySelectorAll('.il-faq__question');

    faqs.forEach(faq => {
        faq.addEventListener('click', (e) => {
            toggleFaq(e.currentTarget);
        });
    });
}

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', initFaq);
} else {
    initFaq();
}